<ion-header>
  <ion-toolbar color="light">
    <ion-title>{{'ENTERPRISE.ADD'|translate}}</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content scrollY="true">
  <div class="ion-padding">
    <ion-row class="ion-justify-content-center">
      <h6 class="ion-text">{{'ENTERPRISE.ENTER_ACCESS_TOKEN'|translate}}</h6>
    </ion-row>
    <form [formGroup]="formGroup">
      <ion-item>
        <ion-label position="floating">{{'TOKEN'|translate}}</ion-label>
        <ion-input formControlName="code" aria-label="Code"></ion-input>
      </ion-item>
      <app-validation-error [formGroup]="formGroup" [validationMessages]="validationMessages" [controlName]="'code'">
      </app-validation-error>
    </form>
  </div>
</ion-content>
<ion-footer>
  <ion-toolbar>
    <ion-buttons slot="primary">
      <ion-button fill="solid" color="danger" (click)="onClickCancel()">
        {{'CANCEL'|translate}}
      </ion-button>
      <ion-button fill="solid" color="primary" (click)="onClickOk()" [disabled]="!(formGroup.touched && formGroup.valid)">
        {{'ADD'|translate}}
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-footer>
